<template>
  <ListItem>
    <div class="text-xs leading-5 text-surface-500">
      <div class="flex flex-col justify-between items-start w-full" v-if="showInitiatedBy || showInitiatedAt">
        <span class="text-surface-800 flex-1 font-medium" v-if="showInitiatedBy">
          {{ log.causer?.name || $t('common.na') }}
        </span>
        <span class="text-surface-400" v-if="showInitiatedAt"><time>{{ $d(Date.parse(log.created_at), 'long') }}</time></span>
      </div>
    </div>
  </ListItem>
</template>

<script>
import ListItem from "@/Components/ListItem.vue";

export default {
  name: "DevicesConfigUpdatesListItem",
  components: {
    ListItem,
  },
  props: {
    log: {
      type: Object,
      required: true,
    },
    showInitiatedAt: {
      type: Boolean,
      default: true,
    },
    showInitiatedBy: {
      type: Boolean,
      default: true,
    }
  },
}
</script>

<style scoped>

</style>
